import React from "react";
import Cards from "./SponsCard";
import styles from "./SponsCardSec.module.css";

import image1 from "../../images/sponsor logos/1.png"
import image2 from "../../images/sponsor logos/2.jpeg";
import image3 from "../../images/sponsor logos/3.jpeg";
import image4 from "../../images/sponsor logos/4.jpeg";
import image5 from "../../images/sponsor logos/5.jpeg";
import image6 from "../../images/sponsor logos/6.jpeg";
import image7 from "../../images/sponsor logos/7.jpeg";
import image8 from "../../images/sponsor logos/8.jpeg";
import image9 from "../../images/sponsor logos/9.jpeg";
import image10 from "../../images/sponsor logos/10.jpeg";
import image11 from "../../images/sponsor logos/11.jpeg";
import image12 from "../../images/sponsor logos/12.jpeg";
import image13 from "../../images/sponsor logos/13.jpeg";
import image14 from "../../images/sponsor logos/14.jpeg";
import image15 from "../../images/sponsor logos/15.jpeg";
import image16 from "../../images/sponsor logos/16.jpeg";
import image17 from "../../images/sponsor logos/17.jpeg";
import image18 from "../../images/sponsor logos/18.jpeg";
import image19 from "../../images/sponsor logos/19.jpeg";
import image20 from "../../images/sponsor logos/20.jpeg";
import image21 from "../../images/sponsor logos/21.jpeg";
import image22 from "../../images/sponsor logos/22.jpeg";
import image23 from "../../images/sponsor logos/23.jpeg";
import image24 from "../../images/sponsor logos/24.jpeg";
import image25 from "../../images/sponsor logos/25.jpeg";
import image26 from "../../images/sponsor logos/26.jpeg";
import image27 from "../../images/sponsor logos/27.jpeg";
import image28 from "../../images/sponsor logos/28.jpeg";
import image29 from "../../images/sponsor logos/29.jpeg";
import image30 from "../../images/sponsor logos/30.jpeg";
import image31 from "../../images/sponsor logos/31.jpeg";
import image32 from "../../images/sponsor logos/32.jpeg";
import image33 from "../../images/sponsor logos/33.jpeg";
import image34 from "../../images/sponsor logos/34.jpeg";
import image35 from "../../images/sponsor logos/35.jpeg";

function SponsCardSec() {

    return (
        <div className={styles.cardSec}>
        <Cards image={image1} class={styles.main} />
            <div className={styles.container}>
                <Cards image={image2} class={styles.card}/>
                <Cards image={image3} class={styles.card}/>
                <Cards image={image4} class={styles.card}/>
                <Cards image={image5} class={styles.card}/>
                <Cards image={image6} class={styles.card}/>
                <Cards image={image7} class={styles.card}/>
                <Cards image={image8} class={styles.card}/>
                <Cards image={image9} class={styles.card}/>
                <Cards image={image10} class={styles.card}/>
                <Cards image={image11} class={styles.card}/>
                <Cards image={image12} class={styles.card}/>
                <Cards image={image13} class={styles.card}/>
                <Cards image={image14} class={styles.card}/>
                <Cards image={image15} class={styles.card}/>
                <Cards image={image16} class={styles.card}/>
                <Cards image={image17} class={styles.card}/>
                <Cards image={image18} class={styles.card}/>
                <Cards image={image19} class={styles.card}/>
                <Cards image={image20} class={styles.card}/>
                <Cards image={image21} class={styles.card}/>
                <Cards image={image22} class={styles.card}/>
                <Cards image={image23} class={styles.card}/>
                <Cards image={image24} class={styles.card}/>
                <Cards image={image25} class={styles.card}/>
                <Cards image={image26} class={styles.card}/>
                <Cards image={image27} class={styles.card}/>
                <Cards image={image28} class={styles.card}/>
                <Cards image={image29} class={styles.card}/>
                <Cards image={image30} class={styles.card}/>
                <Cards image={image31} class={styles.card}/>
                <Cards image={image32} class={styles.card}/>
                <Cards image={image33} class={styles.card}/>
                <Cards image={image34} class={styles.card}/>
                <Cards image={image35} class={styles.card}/>
            </div>
        </div>



    );
}

export default SponsCardSec;